<template>
    <tr>
        <td>{{ entry_date }}</td>
        <td>{{ entry_hour }}</td>
        <td>{{ entry_user }}</td>
        <td>{{ entry_action }}</td>
        <td>{{ entry_status }}</td>
        <td>
            <button class="btn btn-wabident-round small" :id="'view_log_entry_' + entry.id"> Ver ...</button>
            <b-popover :target="'view_log_entry_' + entry.id" triggers="click" placement="righttop">
                    <div><b>De:</b> {{ entry_from }}</div>
                    <div><b>A:</b> {{ entry_to }}</div>
                    <div><b>Doctor:</b> {{ entry_doctor }}</div>
                    <div><b>Box:</b> {{ entry_box }}</div>
                    <div><b>Notas:</b> {{ entry_notes }}</div>
                    <div><b>Estado:</b> {{ entry_status }}</div>
                    <div><b>Tratamientos:</b> {{ entry_treatments }}</div>
            </b-popover>
        </td>
    </tr>
</template>

<script>
export default {
    props: ['entry'],
    computed: {
        entry_date() {
            return moment(this.entry.created_at).format('DD/MM/YY');
        },
        entry_hour() {
            return moment(this.entry.created_at).format('HH:mm');
        },
        entry_user() {
            const user = this.clinic.users.filter((u) => {
                return u.id == this.entry.user_id;
            })[0];

            if (!user) return '';
            return user.name + (user.is_active ? '' : ' (Inac.)');
        },
        entry_action() {
            return this.entry.action;
        },
        entry_data() {
            return JSON.stringify(this.entry.data);
        },
        entry_from() {
            return moment(this.entry.data.date_from).format('DD/MM/YY HH:mm');
        },
        entry_to() {
            return moment(this.entry.data.date_to).format('DD/MM/YY HH:mm');
        },
        entry_doctor() {
            if (!this.entry.data.doctor_id) return 'No';

            const user = this.clinic.users.filter((u) => {
                return u.doctor && (u.doctor.id == this.entry.data.doctor_id);
            })[0];

            if (!user) return 'N/D';
            return user.name + (user.is_active ? '' : ' (Inac.)');
        },
        entry_box() {
            if(!this.entry.data.box_id) return 'No';

            const box = this.clinic.boxes.filter((b) => {
                return b.id == this.entry.data.box_id;
            })[0];

            if (!box) return 'N/D';
            return box.name;
        },
        entry_notes() {
            return this.entry.data.notes;
        },
        entry_status() {
            const statuses = {
                pending: 'Pendiente',
                confirmed: 'Confirmada',
                arrived: 'Llegó',
                attended: 'Atendid@',
                treated: 'Tratado',
                cancel: 'Canceló',
                absent: 'Ausencia',
                gone: 'Se fué',
                leaving: 'Saliendo',
            };
            return statuses[this.entry.data.status] || 'Pendiente';
        },
        entry_treatments() {
            return this.entry.data.treatments ? this.entry.data.treatments.length : 'No';
        },
        ...mapGetters(['clinic','is_core'])
    },
}
</script>